import React from "react";

import { MenuItemBadges } from "features/MenuItemBadges";
import { PageTitle } from "shared/ui";

const MenuItemBadgesPage = () => (
    <>
        <PageTitle>Бейджи позиций</PageTitle>
        <MenuItemBadges />
    </>
);

export default MenuItemBadgesPage;
